module.exports = __webpack_public_path__ + "img/empty-icon-green.e013d1fe.svg";